export default __webpack_public_path__ + "img/EALMS.1284f0cd.png";